import React from 'react'
import { makeStyles } from '@mui/styles'
import { Card, Box } from '@mui/material'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

interface CardChartProps {
  title: string
  subTitle: string
  subTitle2?: string
  maxWidth: number
  maxHeight: number
  minHeight?: string | number
  children?: JSX.Element | JSX.Element[]
  className?: string
  action?: (event: React.MouseEvent) => void // Evento al hacer click
  color?: string
}

export const CardChart: React.FC<CardChartProps> = ({
  title,
  subTitle,
  subTitle2,
  children,
  maxWidth,
  maxHeight,
  className,
  minHeight,
  action,
  color
}) => {
  const useStyles = makeStyles(() => ({
    root: {
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      backgroundColor: 'rgba(0, 0, 0, 0.07)',
      transition: 'transform 0.15s ease-in-out',
      '&:hover': { transform: 'scale3d(1.05, 1.05, 1.05)', opacity: 1 }
    },
    title: {
      textAlign: 'center',
      textAlignLast: 'center',
      '&hover:': { opacity: 1 }
    },
    subTitle: {
      textAlign: 'center',
      textAlignLast: 'center',
      '&hover:': { opacity: 1 },
      wordWrap: 'break-word'
    },
    textColor: { color: '#1769aa', fontWeight: 600 }
  }))

  const classes = useStyles()

  return (
    <Card className={classes.root} onClick={action}>
      <CardActionArea>
        <CardContent>
          <Box mt={1}>
            <Typography
              gutterBottom
              variant='h5'
              component='h2'
              className={`${classes.title} ${classes.textColor} ${className}`}
            >
              {title}
            </Typography>
            <Typography
              variant='body2'
              color='textSecondary'
              component='p'
              className={classes.subTitle}
            >
              {subTitle}
            </Typography>
            <Typography
              variant='body2'
              color='textSecondary'
              component='p'
              className={classes.subTitle}
            >
              {subTitle2}
            </Typography>
          </Box>
          {color !== '' && (
            <div
              style={{
                background: color,
                height: '40px',
                width: '260px',
                borderRadius: '0 0 4px 4px',
                marginLeft: '-16px',
                position: 'relative',
                bottom: '-32px'
              }}
            ></div>
          )}
        </CardContent>
        <CardContent>{children}</CardContent>
      </CardActionArea>
    </Card>
  )
}
